import { GET_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetForm3cForm25List = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Form3cForm25Report/GetList?` + params, null);